const LoadingSpinner = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-blue-600 mx-auto"></div>
      <p className="mt-4 text-gray-600">Loading order details...</p>
    </div>
  </div>
);

export default LoadingSpinner;